import * as React from 'react';
import Svg, { Rect, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const RipsProductIcon = (props: SvgProps & { fill?: string }) => (
    <Svg width={16} height={16} {...props} fill="none" viewBox="0 0 16 16">
        <Rect
            x={3}
            y={8}
            width={10}
            height={6}
            stroke={props.fill || ds.colorValue.icon.primary}
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <Rect
            x={3}
            y={2}
            width={10}
            height={3}
            stroke={props.fill || ds.colorValue.icon.primary}
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);
